export const Constant = {
  DEFAULT_DURATION_IN_MS: 200,
  DEFAULT_DELAY_IN_MS: 0,

  MIN_TRANSLATE_X: -100,
  INITIAL_TRANSLATE_X: 0,
  MAX_TRANSLATE_X: 100,

  DAMPING: 3,
  REST_SPEED_THRESHOLD: 1,
  STIFFNESS: 1000,
  VELOCITY: 1000,
};
